// extracted by mini-css-extract-plugin
module.exports = {"Menu":"ur_a vh_h","Menu__offsetParent":"ur_b vh_bi","Menu__trigger--shadowed":"ur_c"};